<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="prefix" v-if="component.prefix">{{ component.prefix }}</span>
          <span style="white-space: pre-line" class="text" v-html="getValue()"></span>
          <span class="suffix" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component', 'components', 'value'],
  name: 'TextareaReadOnly',
  methods: {
    getValue: function () {
      return this.value || '-'
    }
  }
}
</script>
